import { Badge } from "@shared/ui/badge";
import { Calendar } from "lucide-react";
import React from "react";

interface InstallmentCardProps {
  installment: any;
  isSelected: boolean;
  onToggle: (installmentId: string) => void;
  currency: string;
  index: number;
}

export const InstallmentCard: React.FC<InstallmentCardProps> = ({
  installment,
  isSelected,
  onToggle,
  currency,
  index,
}) => {
  const getStatusBadge = (status: any["status"]) => {
    return status === "Overdue"
      ? "bg-red-100 text-red-800"
      : "bg-yellow-100 text-yellow-800";
  };

  const amount = installment.installmentAmount ?? 0;
  const dueDate = installment.dueDate;
  const status = installment.status;
  const agreementId = installment.agreementId;

  return (
    <div
      className={`border rounded-lg p-4 cursor-pointer transition-all ${
        isSelected
          ? "border-blue-500 bg-blue-50"
          : "border-gray-200 hover:border-gray-300"
      }`}
      onClick={() => onToggle(installment.id)}
    >
      <div className="flex items-start gap-3">
        {/* Number Badge */}
        <div className="flex-shrink-0">
          <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center font-semibold text-gray-700 text-sm">
            #{index + 1}
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <div className="flex flex-col gap-1.5">
              {dueDate && (
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <Calendar className="w-4 h-4" />
                  <span>{dueDate}</span>
                </div>
              )}

              <div className="flex items-center gap-2">
                {status && (
                  <Badge className={getStatusBadge(status)}>{status}</Badge>
                )}
                {agreementId && (
                  <span className="text-xs text-gray-500">{agreementId}</span>
                )}
              </div>
            </div>

            <span className="text-lg font-bold text-gray-900">
              {currency} {amount}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
